<svg
  id="eiw94gKLAWY1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 400 400"
  shape-rendering="geometricPrecision"
  text-rendering="geometricPrecision"
  width="400"
  height="400"
>
  <defs>
    <polygon
      id="eiw94gKLAWY2"
      points="175.8,82.9 212.7,133.9 184.9,170.8 241.2,170.8 187.3,225.5 236.9,247.3 187.3,298.7 74.4,298.7 74.4,242 165.4,86.5"
    />
    <polyline
      id="eiw94gKLAWY3"
      points="175.8,82.9 186,67.9 234.1,67.9 337.7,249.9 337.7,298.7 187.3,298.7 236.9,247.3 187.3,225.5 241.2,170.8 184.9,170.8 212.7,133.9 175.8,82.9"
    />
  </defs>
  <g id="eiw94gKLAWY4_ts" transform="translate(205.879143,184.737511) scale(0,0)">
    <g transform="translate(-205.879143,-184.737511)">
      <g>
        <path
          d="M170.1,91.4L85.8,236.6c-16,27.6,3.9,62.1,35.8,62.1h168.6c31.9,0,51.7-34.5,35.8-62.1L241.6,91.4c-16-27.5-55.6-27.5-71.5,0Z"
          fill="#f39200"
        />
      </g>
    </g>
  </g>
  <g id="eiw94gKLAWY7_ts" transform="translate(205.849991,184.974998) scale(0,0)">
    <g transform="translate(-205.849991,-184.974998)">
      <g>
        <g>
          <path
            d="M180,97.8L96.6,242.3C85.1,262.2,99.5,287,122.4,287h166.9c22.9,0,37.3-24.8,25.8-44.7L231.6,97.8C220.1,78,191.5,78,180,97.8Z"
            fill="#f7a623"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="eiw94gKLAWY11_to" transform="translate(205.727013,202.749496)">
    <g id="eiw94gKLAWY11_ts" transform="scale(0,0)">
      <g transform="translate(-205.727013,-202.749496)">
        <g>
          <path
            d="M198.9,219l-8.4-55.7c-1.3-8.4,5.2-16,13.7-16.1h2.8c8.5-.1,15.1,7.4,14,15.8l-7.2,55.9c-1,8.7-13.6,8.8-14.9.1Z"
            fill="#17132b"
          />
          <circle r="11" transform="translate(205.8 247.3)" fill="#17132b" />
        </g>
      </g>
    </g>
  </g>
  <g display="none">
    <g>
      <g clip-path="url(#eiw94gKLAWY25)">
        <g>
          <g>
            <g>
              <path
                d="M325.2,236.6c16,27.6-3.9,62.1-35.8,62.1h-168.5c-31.9,0-51.8-34.5-35.8-62.1L169.4,91.3c15.9-27.4,55.6-27.4,71.5,0l84.3,145.3ZM288.6,287c22.9,0,37.3-24.8,25.8-44.7L231,97.8c-11.5-19.9-40.1-19.9-51.6,0L95.9,242.4c-11.5,19.9,2.9,44.7,25.8,44.7h166.9Z"
                fill="#f39200"
              />
              <path
                d="M314.4,242.4c11.5,19.9-2.9,44.7-25.8,44.7h-166.9c-22.9,0-37.3-24.8-25.8-44.7L179.3,97.9c11.5-19.9,40.1-19.9,51.6,0l83.5,144.5ZM220.5,163c1.1-8.4-5.5-15.9-14-15.8h-2.8c-8.5.1-15,7.7-13.7,16.1l8.4,55.7c1.3,8.7,13.9,8.6,15-.2l7.1-55.8Zm-4.3,84.3c0-6.1-4.9-11-11-11s-11,4.9-11,11s4.9,11,11,11s11-4.9,11-11Z"
                fill="#f7a623"
              />
              <path
                d="M206.4,147.2c8.5-.1,15.1,7.4,14,15.8l-7.2,55.9c-1.1,8.7-13.7,8.9-15,.2l-8.4-55.7c-1.3-8.4,5.2-16,13.7-16.1l2.9-.1Z"
                fill="#17132b"
              />
              <path d="M205.2,236.3c6.1,0,11,4.9,11,11s-4.9,11-11,11-11-4.9-11-11c0-6,4.9-11,11-11Z" fill="#17132b" />
            </g>
          </g>
        </g>
        <clipPath id="eiw94gKLAWY25">
          <use width="166.799988" height="215.800018" xlink:href="#eiw94gKLAWY2" />
        </clipPath>
      </g>
    </g>
  </g>
  <g display="none">
    <g>
      <g clip-path="url(#eiw94gKLAWY37)">
        <g>
          <g>
            <g>
              <path
                d="M325.2,236.6c16,27.6-3.9,62.1-35.8,62.1h-168.5c-31.9,0-51.8-34.5-35.8-62.1L169.4,91.3c15.9-27.4,55.6-27.4,71.5,0l84.3,145.3ZM288.6,287c22.9,0,37.3-24.8,25.8-44.7L231,97.8c-11.5-19.9-40.1-19.9-51.6,0L95.9,242.4c-11.5,19.9,2.9,44.7,25.8,44.7h166.9Z"
                fill="#f39200"
              />
              <path
                d="M314.4,242.4c11.5,19.9-2.9,44.7-25.8,44.7h-166.9c-22.9,0-37.3-24.8-25.8-44.7L179.3,97.9c11.5-19.9,40.1-19.9,51.6,0l83.5,144.5ZM220.5,163c1.1-8.4-5.5-15.9-14-15.8h-2.8c-8.5.1-15,7.7-13.7,16.1l8.4,55.7c1.3,8.7,13.9,8.6,15-.2l7.1-55.8Zm-4.3,84.3c0-6.1-4.9-11-11-11s-11,4.9-11,11s4.9,11,11,11s11-4.9,11-11Z"
                fill="#f7a623"
              />
              <path
                d="M206.4,147.2c8.5-.1,15.1,7.4,14,15.8l-7.2,55.9c-1.1,8.7-13.7,8.9-15,.2l-8.4-55.7c-1.3-8.4,5.2-16,13.7-16.1l2.9-.1Z"
                fill="#17132b"
              />
              <path d="M205.2,236.3c6.1,0,11,4.9,11,11s-4.9,11-11,11-11-4.9-11-11c0-6,4.9-11,11-11Z" fill="#17132b" />
            </g>
          </g>
        </g>
        <clipPath id="eiw94gKLAWY37">
          <use width="161.900009" height="230.800018" xlink:href="#eiw94gKLAWY3" />
        </clipPath>
      </g>
    </g>
  </g>
</svg>
